var r=e=>!!e;var t=(e="lang")=>()=>[window?.sessionStorage?.getItem(e)].filter(r),lr=t();export{t as initSessionStorageDetector,lr as sessionStorageDetector};
